export default {
  'AI Face Animator': 'AI Yüz Animatörü',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'Beyin yıkama müziğiyle inanılmaz yüz ifadeleri oluşturun, eğlenmek için sihri bulun.',
  'Upload a photo': 'Bir fotoğraf yükle',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'Not: Lütfen seçtiğiniz fotoğraflardaki yüzün lense baktığından emin olun, aksi takdirde başarıyla işlenemez.',
  'Uploaded successfully!': 'Başarıyla yüklendi!',
  'Please select a template below': 'Lütfen aşağıdan bir şablon seçin',
  'Choose a GIF': 'Bir GIF seçin',
  'Use this template': 'Bu şablonu kullanın',
  'Verify successfully! You will': 'Başarıyla doğrulayın! {{email}} ile kısa süre içinde videoyu alacaksınız.',
  'You will': '{{email}} ile kısa süre içinde videoyu alacaksınız.',
  'What you should expect to happen next': 'Bundan sonra olmasını beklemeniz gerekenler:',
  'We will process your photo into a dynamic video.': 'Fotoğrafınızı dinamik bir video olarak işleyeceğiz.',
  'After processing, we will send the video to your email.': 'İşlemden sonra videoyu e-postanıza göndereceğiz.',
  'You can check the video in your email.': 'E-postanızdaki videoyu kontrol edebilirsiniz.',
  'Your video will be delivered via email': 'Videonuz e-posta yoluyla teslim edilecek',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'Dinamik bir videoyu sentezlemek 20-30 dakika sürer, lütfen sabırlı olun. Gizliliğinizi korumak için, yüklenen resimler işlem bittikten sonra otomatik olarak silinecektir.',
  'Your Email': 'E-posta adresiniz',
  'Last Name': 'Adı',
  'First Name': 'Soyadı',
  'Go back': 'Geri git',
  'Invalid email address':'Geçersiz e-posta adresi',
  'Enter verification code':'Doğrulama kodunu girin',
  'Enter the verification code that we sent to': "{{email}}'e gönderdiğimiz doğrulama kodunu girin.",
  'Resend': 'Yeniden gönder',
  'Verification code': 'Doğrulama kodu',
  'Resend after': '{{num}} saniye sonra yeniden gönder',
  'The verification code is invalid. You can request a new one.': 'Doğrulama kodu geçersiz. Yeni bir tane isteyebilirsiniz.',
  'Synthesize Video': 'Videoyu Sentezle',
  'Too many attempts, please try again later.': 'Çok fazla denendi. Lütfen daha sonra tekrar deneyin',
}